import { Colors } from "@blueprintjs/core";
import { useLocation } from "react-router";

import { Box } from "@/components/layout/flexbox";
import { ScrollParent } from "@/components/layout/ScrollParent";
import { STANDARD_NAV_HEIGHT } from "@/css/constants";

interface SectionContainerProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  headerHeight: number;
  flex?: string | number;
  width?: number | number[];
}

export function SectionContainer({
  children,
  header,
  headerHeight,
  flex,
  width,
}: SectionContainerProps) {
  const location = useLocation();

  const heightOffset = location.pathname.startsWith("/client")
    ? STANDARD_NAV_HEIGHT * 2
    : STANDARD_NAV_HEIGHT;

  return (
    <Box
      width={width}
      flex={flex}
      style={{ position: "relative", backgroundColor: Colors.WHITE }}
    >
      <ScrollParent heightOffset={heightOffset} className="brs">
        <Box pt={headerHeight}>{children}</Box>
      </ScrollParent>
      <Box
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        {header}
      </Box>
    </Box>
  );
}
